import { handleReceiveEvent } from 'state/system_notification'

import { application } from '../application'

export const initializeMessaging = async () => {
	await application.peek().forEventsMessaging().initialize()
}

export const subscribeToUpdates = async (subjects: string[]) => {
	await application
		.peek()
		.forEventsMessaging()
		.subscribeToUpdates(subjects, handleReceiveEvent)
}

export const shutdownMessaging = async () => {
	await application.peek().forEventsMessaging().shutdown()
}
